(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@splat/iconfont"), require("@splat/constant"), require("csstips"), require("csx"), require("typestyle"), require("moment"), require("vue-property-decorator"), require("vue-tsx-support"), require("@splat/validator"), require("@splat/form-item"), require("core-js/modules/esnext.global-this.js"));
	else if(typeof define === 'function' && define.amd)
		define([, , , , , , , , , , "core-js/modules/esnext.global-this.js"], factory);
	else if(typeof exports === 'object')
		exports["time-picker"] = factory(require("@splat/iconfont"), require("@splat/constant"), require("csstips"), require("csx"), require("typestyle"), require("moment"), require("vue-property-decorator"), require("vue-tsx-support"), require("@splat/validator"), require("@splat/form-item"), require("core-js/modules/esnext.global-this.js"));
	else
		root["time-picker"] = factory(root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root["core-js/modules/esnext.global-this.js"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__splat_iconfont__, __WEBPACK_EXTERNAL_MODULE__splat_constant__, __WEBPACK_EXTERNAL_MODULE_csstips__, __WEBPACK_EXTERNAL_MODULE_csx__, __WEBPACK_EXTERNAL_MODULE_typestyle__, __WEBPACK_EXTERNAL_MODULE_moment__, __WEBPACK_EXTERNAL_MODULE_vue_property_decorator__, __WEBPACK_EXTERNAL_MODULE_vue_tsx_support__, __WEBPACK_EXTERNAL_MODULE__splat_validator__, __WEBPACK_EXTERNAL_MODULE__splat_form_item__, __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_global_this_js__) {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/locales/index.ts":
/*!******************************!*\
  !*** ./src/locales/index.ts ***!
  \******************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I18nProvider": function() { return /* binding */ I18nProvider; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var core_js_modules_esnext_global_this_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/esnext.global-this.js */ "core-js/modules/esnext.global-this.js");
/* harmony import */ var core_js_modules_esnext_global_this_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_global_this_js__WEBPACK_IMPORTED_MODULE_3__);




var I18nProvider = /*#__PURE__*/function () {
  function I18nProvider(maps, _lang, fallback) {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, I18nProvider);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(this, "maps", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(this, "_lang", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(this, "fallback", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(this, "subs", new Set());

    this.maps = maps;
    this._lang = _lang;
    this.fallback = fallback;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(I18nProvider, [{
    key: "lang",
    get: function get() {
      return this._lang;
    }
  }, {
    key: "setLanguage",
    value: function setLanguage(lang) {
      if (this._lang === lang) return;
      this._lang = lang;
      this.subs.forEach(function (x) {
        return x(lang);
      });
    }
  }, {
    key: "addSub",
    value: function addSub(cb) {
      this.subs.add(cb);
    }
  }, {
    key: "removeSub",
    value: function removeSub(cb) {
      this.subs.delete(cb);
    }
  }, {
    key: "t",
    get: function get() {
      return this.maps[this.lang] || this.maps[this.fallback];
    }
  }]);

  return I18nProvider;
}();
var provider = new I18nProvider({
  'en-US': {
    timePicker: {
      timeRange: {
        to: '/',
        start: 'start',
        end: 'end'
      }
    }
  },
  'zh-CHT': {
    timePicker: {
      timeRange: {
        to: '/',
        start: "\u958B\u59CB\u6642\u9593",
        end: "\u7D50\u675F\u6642\u9593"
      }
    }
  },
  'zh-CN': {
    timePicker: {
      timeRange: {
        to: '/',
        start: "\u5F00\u59CB\u65F6\u95F4",
        end: "\u7ED3\u675F\u65F6\u95F4"
      }
    }
  }
}, globalThis.__splatI18nProvider ? globalThis.__splatI18nProvider.lang : 'zh-CN', globalThis.__splatI18nProvider ? globalThis.__splatI18nProvider.lang : 'zh-CN');
/* harmony default export */ __webpack_exports__["default"] = (provider);

/***/ }),

/***/ "./src/style.ts":
/*!**********************!*\
  !*** ./src/style.ts ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "timePickerHackClassName": function() { return /* binding */ timePickerHackClassName; },
/* harmony export */   "timeRangeItemHackClassName": function() { return /* binding */ timeRangeItemHackClassName; },
/* harmony export */   "datetimeRangeItemHackClassName": function() { return /* binding */ datetimeRangeItemHackClassName; },
/* harmony export */   "datetimeRangeItemCompatHackClassName": function() { return /* binding */ datetimeRangeItemCompatHackClassName; },
/* harmony export */   "timeRangePopoverClassName": function() { return /* binding */ timeRangePopoverClassName; },
/* harmony export */   "hideIconTime": function() { return /* binding */ hideIconTime; },
/* harmony export */   "itemFocusClassName": function() { return /* binding */ itemFocusClassName; },
/* harmony export */   "preventHoverClassName": function() { return /* binding */ preventHoverClassName; },
/* harmony export */   "disabledClassName": function() { return /* binding */ disabledClassName; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var csstips__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! csstips */ "csstips");
/* harmony import */ var csstips__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(csstips__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! csx */ "csx");
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(csx__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_4__);


var _elInput__suffix, _elRange__closeI;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var timePickerHackClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  cursor: 'pointer',
  width: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(230),
  $nest: {
    '&.el-input--prefix .el-input__inner': {
      paddingLeft: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(9),
      letterSpacing: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(0.5)
    },
    '&.el-date-editor.el-input': {
      width: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(230)
    },
    '&.el-input--small .el-input__icon': {
      lineHeight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(24),
      color: '#666'
    },
    '&.el-input--small .el-input__inner': {
      background: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.background.toString(),
      border: 'none',
      height: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(24),
      lineHeight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(24),
      color: '#333',
      cursor: 'pointer',
      $nest: {
        '&:hover': {
          background: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.backgroundHighlight.toString()
        },
        '&:focus': {
          background: 'rgba(233, 233, 233, .8)'
        },
        '&::-webkit-input-placeholder': {
          color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.normalText.toString()
        }
      }
    },
    '& .el-input__prefix': csstips__WEBPACK_IMPORTED_MODULE_2__.invisible,
    '& .el-input__suffix .el-input__suffix-inner .el-input__icon': (_elInput__suffix = {
      fontFamily: 'iconfont',
      fontStyle: 'normal'
    }, (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_elInput__suffix, '-webkit-font-smoothing', 'antialiased'), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_elInput__suffix, '-moz-osx-font-smoothing', 'grayscale'), _elInput__suffix),
    '& .el-input__suffix .el-input__suffix-inner .el-input__icon:before': {
      content: "\"\\e65a\""
    },
    '& .el-input__suffix .el-input__suffix-inner .el-input__icon.icon-close:before': {
      content: "\"\\e63a\""
    }
  }
});
(0,typestyle__WEBPACK_IMPORTED_MODULE_4__.cssRule)('body .el-time-panel.el-popper', {
  left: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(-20)
});
var timeRangeItemCompatHack = {
  height: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(24)),
  lineHeight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(16)),
  paddingLeft: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(5)),
  paddingRight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(24)),
  cursor: 'pointer',
  $nest: {
    '&:hover': {
      background: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.backgroundHighlight.toString()),
      $nest: {
        '& .el-range-input': {
          background: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.backgroundHighlight.toString())
        },
        '&.el-range-editor--small': {
          borderColor: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.backgroundHighlight.toString())
        }
      }
    },
    '& *': {
      lineHeight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(16))
    },
    '& .el-range-input': {
      cursor: 'pointer',
      width: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)((0,csx__WEBPACK_IMPORTED_MODULE_3__.percent)(44)),
      minWidth: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(130)),
      fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(12)),
      color: '#333',
      $nest: {
        '&::-webkit-input-placeholder': {
          color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.normalText.toString()
        }
      }
    },
    '& .el-range-separator': {
      paddingLeft: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(1)),
      paddingRight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(1)),
      color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.normalText.toString()
    },
    '& .el-input__icon': {
      width: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(16))
    },
    '&.el-range-editor--small .el-input__icon': {
      lineHeight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(24),
      color: '#666'
    },
    '&.el-range-editor--small': {
      borderColor: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.background.toString(),
      height: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(24),
      lineHeight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(24)
    },
    '&.el-range-editor--small, &.el-range-editor--small .el-range-input': {
      background: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.background.toString()
    },
    '& .el-icon-time': csstips__WEBPACK_IMPORTED_MODULE_2__.invisible,
    '&.el-range-editor.el-input__inner > i.el-input__icon.el-range__close-icon': {
      right: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(5),
      position: 'absolute'
    },
    '& .el-range__close-icon.el-input__icon, & .el-range__close-icon.el-icon-circle-close': (_elRange__closeI = {
      fontFamily: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)('iconfont'),
      fontStyle: 'normal'
    }, (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_elRange__closeI, '-webkit-font-smoothing', 'antialiased'), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_elRange__closeI, '-moz-osx-font-smoothing', 'grayscale'), _elRange__closeI),
    '& .el-range__close-icon.el-input__icon:before': {
      content: "\"\\e65a\""
    },
    '& .el-range__close-icon.el-input__icon.el-icon-circle-close:before': {
      content: "\"\\e63a\""
    },
    '&.el-range-editor.is-active:hover': {
      borderColor: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)('#409EFF')
    },
    '&.el-input__inner': {
      transition: 'none'
    }
  }
};
var timeRangeItemHackClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(_objectSpread({
  width: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(315)),
  minWidth: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(315))
}, timeRangeItemCompatHack));
var datetimeRangeItemHackClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(_objectSpread({
  width: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(315)),
  minWidth: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(315))
}, timeRangeItemCompatHack));
var datetimeRangeItemCompatHackClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  $nest: {
    '&:hover': {
      background: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.backgroundHighlight.fade(0.8).toString(),
      $nest: {
        '& .el-range-input': {
          background: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.backgroundHighlight.fade(0.8).toString()
        }
      }
    }
  }
});
var timeRangePopoverClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  $nest: {
    '.el-time-panel.el-popper': {
      left: 'auto',
      right: 0
    }
  }
});
var hideIconTime = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  $nest: {
    '& .el-icon-time': {
      display: 'none'
    }
  }
});
var itemFocusClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  background: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)('rgba(233, 233, 233, .8)'),
  $nest: {
    '& .el-range-input': {
      background: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)('rgba(233, 233, 233, .8)')
    },
    '&.el-range-editor--small': {
      borderColor: 'rgba(233, 233, 233, .2)'
    }
  }
});
var preventHoverClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  $nest: {
    '&:hover': {
      background: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.background.toString()),
      $nest: {
        '& .el-range-input': {
          color: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)('#C0C4CC'),
          cursor: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)('not-allowed'),
          background: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.background.toString())
        },
        '&.el-range-editor--small': {
          borderColor: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.background.toString())
        }
      }
    },
    '&.el-range-editor.is-active:hover': {
      borderColor: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.background.toString())
    }
  }
});
var disabledClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  $nest: {
    '&.el-input--small .el-input__inner': {
      color: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)('#C0C4CC'),
      cursor: (0,csx__WEBPACK_IMPORTED_MODULE_3__.important)('not-allowed'),
      $nest: {
        '&:hover': {
          background: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.background.toString()
        },
        '&:focus': {
          background: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.background.toString()
        }
      }
    }
  }
});

/***/ }),

/***/ "./src/timeRange.tsx":
/*!***************************!*\
  !*** ./src/timeRange.tsx ***!
  \***************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TimeRangePickerType": function() { return /* binding */ TimeRangePickerType; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _splat_validator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @splat/validator */ "@splat/validator");
/* harmony import */ var _splat_validator__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_splat_validator__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _splat_form_item__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @splat/form-item */ "@splat/form-item");
/* harmony import */ var _splat_form_item__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_splat_form_item__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _locales__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./locales */ "./src/locales/index.ts");
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./style */ "./src/style.ts");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! vue-tsx-support */ "vue-tsx-support");
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! csx */ "csx");
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(csx__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var csstips__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! csstips */ "csstips");
/* harmony import */ var csstips__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(csstips__WEBPACK_IMPORTED_MODULE_17__);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__["default"])(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};











var TimeRangePickerType;

(function (TimeRangePickerType) {
  TimeRangePickerType["DateTimeRange"] = "datetimerange";
  TimeRangePickerType["DateRange"] = "daterange";
  TimeRangePickerType["TimeRange"] = "timerange";
})(TimeRangePickerType || (TimeRangePickerType = {}));

var TimeRangePicker = /*#__PURE__*/function (_tsx$Component) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__["default"])(TimeRangePicker, _tsx$Component);

  var _super = _createSuper(TimeRangePicker);

  function TimeRangePicker() {
    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, TimeRangePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "value", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "prop", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "index", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "unlinkPanels", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "placeholder", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "compatStyle", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "disabled", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "type", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "transform", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "defaultTime", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "handleFocus", false);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "iValue", _this.value);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "i18n", _locales__WEBPACK_IMPORTED_MODULE_11__["default"]);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "form", null);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "_formInstance", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "i18nInjection", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "i18nProvider", _this.i18n);

    return _this;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(TimeRangePicker, [{
    key: "onInput",
    value: function onInput(v) {
      return this.transform ? this.transform(v) : v;
    }
  }, {
    key: "handleInput",
    value: function handleInput(v) {
      this.onInput(v);
      this.updateState(this.onChanged());
    }
  }, {
    key: "innerValue",
    get: function get() {
      return this.type === TimeRangePickerType.TimeRange ? this.iValue.toDateTupleOrNull() : this.value.toDateTuple();
    },
    set: function set(v) {
      this.type === TimeRangePickerType.TimeRange ? this.iValue = _splat_constant__WEBPACK_IMPORTED_MODULE_8__.TimeRange.fromDateTuple(v ? v : ['', '']) : this.handleDateTupleInput(v);
    }
  }, {
    key: "handleDateTupleInput",
    value: function handleDateTupleInput(v) {
      this.handleInput(_splat_constant__WEBPACK_IMPORTED_MODULE_8__.TimeRange.fromDateTuple(v ? v : ['', '']));
    }
  }, {
    key: "handleFocusInput",
    value: function handleFocusInput() {
      if (!this.disabled) this.handleFocus = true;
    }
  }, {
    key: "handleBlurInput",
    value: function handleBlurInput() {
      this.handleFocus = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _elRangeEditorEl;

      var h = arguments[0];
      return h(_splat_form_item__WEBPACK_IMPORTED_MODULE_10__.FormItemValidateStatus, [this.type === TimeRangePickerType.TimeRange ? h("el-time-picker", {
        "attrs": {
          "disabled": this.disabled,
          "is-range": true,
          "popper-class": _style__WEBPACK_IMPORTED_MODULE_12__.timeRangePopoverClassName,
          "range-separator": this.i18n.t.timePicker.timeRange.to,
          "start-placeholder": this.i18n.t.timePicker.timeRange.start,
          "end-placeholder": this.i18n.t.timePicker.timeRange.end
        },
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_15__.classes)(_style__WEBPACK_IMPORTED_MODULE_12__.timeRangeItemHackClassName, this.handleFocus && _style__WEBPACK_IMPORTED_MODULE_12__.itemFocusClassName, this.disabled && _style__WEBPACK_IMPORTED_MODULE_12__.preventHoverClassName, this.value.timeBefore && this.value.timeAfter ? (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('time-picker', 'full') : undefined),
        "on": {
          "change": this.handleDateTupleInput,
          "focus": this.handleFocusInput,
          "blur": this.handleBlurInput
        },
        "model": {
          value: _this2.innerValue,
          callback: function callback($$v) {
            _this2.innerValue = $$v;
          }
        }
      }) : h("el-date-picker", {
        "attrs": {
          "disabled": this.disabled,
          "popper-class": _style__WEBPACK_IMPORTED_MODULE_12__.timeRangePopoverClassName,
          "type": this.type,
          "default-time": this.defaultTime,
          "range-separator": this.i18n.t.timePicker.timeRange.to,
          "start-placeholder": this.i18n.t.timePicker.timeRange.start,
          "end-placeholder": this.i18n.t.timePicker.timeRange.end,
          "unlink-panels": this.unlinkPanels,
          "editable": false
        },
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_15__.classes)(_style__WEBPACK_IMPORTED_MODULE_12__.datetimeRangeItemHackClassName, this.value.timeBefore && this.value.timeAfter ? (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('date-picker', 'full') : undefined, this.handleFocus && _style__WEBPACK_IMPORTED_MODULE_12__.itemFocusClassName, this.disabled && _style__WEBPACK_IMPORTED_MODULE_12__.preventHoverClassName, !this.compatStyle && !!this.value.valid() && (0,typestyle__WEBPACK_IMPORTED_MODULE_15__.style)({
          paddingRight: (0,csx__WEBPACK_IMPORTED_MODULE_16__.important)((0,csx__WEBPACK_IMPORTED_MODULE_16__.px)(32)),
          $nest: {
            '&.el-range-editor.el-input__inner > i.el-input__icon.el-icon-time': {
              display: 'none'
            }
          }
        }), this.compatStyle && _style__WEBPACK_IMPORTED_MODULE_12__.datetimeRangeItemCompatHackClassName, this.compatStyle && !this.value.valid() && (0,typestyle__WEBPACK_IMPORTED_MODULE_15__.style)({
          $nest: {
            '& > .el-range-input, & > .el-range-separator': csstips__WEBPACK_IMPORTED_MODULE_17__.none,
            '&.el-range-editor.el-input__inner > i.el-input__icon.el-icon-time': {
              width: (0,csx__WEBPACK_IMPORTED_MODULE_16__.important)((0,csx__WEBPACK_IMPORTED_MODULE_16__.percent)(100))
            }
          }
        }), this.compatStyle && (0,typestyle__WEBPACK_IMPORTED_MODULE_15__.style)({
          width: (0,csx__WEBPACK_IMPORTED_MODULE_16__.important)('auto'),
          minWidth: (0,csx__WEBPACK_IMPORTED_MODULE_16__.important)((0,csx__WEBPACK_IMPORTED_MODULE_16__.px)(105)),
          $nest: {
            '&.el-range-editor.el-input__inner > i.el-input__icon.el-icon-time': (_elRangeEditorEl = {
              width: (0,csx__WEBPACK_IMPORTED_MODULE_16__.important)('auto'),
              transition: 'none',
              whiteSpace: 'nowrap',
              paddingLeft: (0,csx__WEBPACK_IMPORTED_MODULE_16__.important)((0,csx__WEBPACK_IMPORTED_MODULE_16__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_8__.CommonSizes.lightLeftRightPadding)),
              paddingRight: (0,csx__WEBPACK_IMPORTED_MODULE_16__.important)((0,csx__WEBPACK_IMPORTED_MODULE_16__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_8__.CommonSizes.lightLeftRightPadding)),
              fontSize: _splat_constant__WEBPACK_IMPORTED_MODULE_8__.CommonSizes.fontSize,
              fontFamily: (0,csx__WEBPACK_IMPORTED_MODULE_16__.important)('inherit')
            }, (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])(_elRangeEditorEl, '-webkit-font-smoothing', (0,csx__WEBPACK_IMPORTED_MODULE_16__.important)('unset')), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])(_elRangeEditorEl, "color", _splat_constant__WEBPACK_IMPORTED_MODULE_8__.CommonColors.normalText.toString()), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])(_elRangeEditorEl, "visibility", 'visible'), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])(_elRangeEditorEl, "textAlign", 'start'), _elRangeEditorEl),
            '&.el-range-editor.el-input__inner > i.el-input__icon.el-icon-time:before': {
              content: "\"".concat(this.placeholder, "\uFF1A\"")
            }
          }
        })),
        "on": {
          "changed": this.handleDateTupleInput,
          "focus": this.handleFocusInput,
          "blur": this.handleBlurInput
        },
        "model": {
          value: _this2.innerValue,
          callback: function callback($$v) {
            _this2.innerValue = $$v;
          }
        }
      })]);
    }
  }, {
    key: "setFormComponent",
    value: function setFormComponent(v) {
      this.form = v;
    }
  }, {
    key: "resetFormComponent",
    value: function resetFormComponent(v) {
      if (this.form === v) {
        this.form = null;
      } else {
        this.form = v;
      }
    }
  }, {
    key: "formItemInstance",
    value: function formItemInstance() {
      return this;
    }
  }, {
    key: "formInstance",
    get: function get() {
      var _formInstance = this._formInstance;
      return _formInstance ? _formInstance() : null;
    }
  }, {
    key: "updateState",
    value: function updateState(v) {
      var _this$form;

      (_this$form = this.form) === null || _this$form === void 0 ? void 0 : _this$form.updateState(v);
    }
  }, {
    key: "updateLang",
    value: function updateLang(l) {
      this.i18n.setLanguage(l);
    }
  }, {
    key: "validate",
    value: function validate() {
      var formInstance = this.formInstance;

      if ((0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.isDef)(formInstance)) {
        var _this$index;

        return formInstance.validate((_this$index = this.index) !== null && _this$index !== void 0 ? _this$index : this.prop);
      }

      return {
        type: _splat_validator__WEBPACK_IMPORTED_MODULE_9__.Status.unknown
      };
    }
  }, {
    key: "onMounted",
    value: function onMounted() {
      return {
        type: _splat_validator__WEBPACK_IMPORTED_MODULE_9__.Status.unknown
      };
    }
  }, {
    key: "onChanged",
    value: function onChanged() {
      return this.validate();
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var prop = this.prop,
          formInstance = this.formInstance,
          index = this.index;

      if ((0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.isDef)(formInstance) && ((0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.isDef)(prop) || (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.isDef)(index))) {
        formInstance.addItem(index !== null && index !== void 0 ? index : prop, this);
      }

      if (this.i18nInjection) {
        this.i18nInjection.addSub(this.updateLang);
        this.i18n.setLanguage(this.i18nInjection.lang);
      }
    }
  }, {
    key: "destroyed",
    value: function destroyed() {
      var prop = this.prop,
          formInstance = this.formInstance,
          index = this.index;

      if ((0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.isDef)(formInstance) && ((0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.isDef)(prop) || (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.isDef)(index))) {
        formInstance.removeItem(index !== null && index !== void 0 ? index : prop);
      }

      if (this.i18nInjection) {
        this.i18nInjection.removeSub(this.updateLang);
      }
    }
  }]);

  return TimeRangePicker;
}(vue_tsx_support__WEBPACK_IMPORTED_MODULE_14__.Component);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)()], TimeRangePicker.prototype, "value", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)()], TimeRangePicker.prototype, "prop", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)()], TimeRangePicker.prototype, "index", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)()], TimeRangePicker.prototype, "unlinkPanels", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)()], TimeRangePicker.prototype, "placeholder", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)()], TimeRangePicker.prototype, "compatStyle", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)()], TimeRangePicker.prototype, "disabled", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)({
  default: TimeRangePickerType.DateTimeRange
})], TimeRangePicker.prototype, "type", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)()], TimeRangePicker.prototype, "transform", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Prop)({
  default: function _default() {
    return ['00:00:00', '23:59:59'];
  }
})], TimeRangePicker.prototype, "defaultTime", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Emit)('input')], TimeRangePicker.prototype, "onInput", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Inject)({
  from: 'formInstance',
  default: null
})], TimeRangePicker.prototype, "_formInstance", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Inject)({
  from: 'i18nInjection',
  default: null
})], TimeRangePicker.prototype, "i18nInjection", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Provide)('formItemInstance')], TimeRangePicker.prototype, "formItemInstance", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Provide)('i18nInjection')], TimeRangePicker.prototype, "i18nProvider", void 0);

TimeRangePicker = __decorate([vue_property_decorator__WEBPACK_IMPORTED_MODULE_13__.Component], TimeRangePicker);
/* harmony default export */ __webpack_exports__["default"] = (TimeRangePicker);

/***/ }),

/***/ "../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js":
/*!***************************************************************************************************************************************************************************!*\
  !*** ../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js ***!
  \***************************************************************************************************************************************************************************/
/***/ (function() {

// dummy js to avoid import error


/***/ }),

/***/ "core-js/modules/esnext.global-this.js":
/*!********************************************************!*\
  !*** external "core-js/modules/esnext.global-this.js" ***!
  \********************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_global_this_js__;

/***/ }),

/***/ "@splat/constant":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"@splat/constant","commonjs2":"@splat/constant"} ***!
  \*****************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_constant__;

/***/ }),

/***/ "@splat/form-item":
/*!*******************************************************************************!*\
  !*** external {"commonjs":"@splat/form-item","commonjs2":"@splat/form-item"} ***!
  \*******************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_form_item__;

/***/ }),

/***/ "@splat/iconfont":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"@splat/iconfont","commonjs2":"@splat/iconfont"} ***!
  \*****************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_iconfont__;

/***/ }),

/***/ "@splat/validator":
/*!*******************************************************************************!*\
  !*** external {"commonjs":"@splat/validator","commonjs2":"@splat/validator"} ***!
  \*******************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_validator__;

/***/ }),

/***/ "csstips":
/*!*************************************************************!*\
  !*** external {"commonjs":"csstips","commonjs2":"csstips"} ***!
  \*************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_csstips__;

/***/ }),

/***/ "csx":
/*!*****************************************************!*\
  !*** external {"commonjs":"csx","commonjs2":"csx"} ***!
  \*****************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_csx__;

/***/ }),

/***/ "moment":
/*!***********************************************************!*\
  !*** external {"commonjs":"moment","commonjs2":"moment"} ***!
  \***********************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_moment__;

/***/ }),

/***/ "typestyle":
/*!*****************************************************************!*\
  !*** external {"commonjs":"typestyle","commonjs2":"typestyle"} ***!
  \*****************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_typestyle__;

/***/ }),

/***/ "vue-property-decorator":
/*!*******************************************************************************************!*\
  !*** external {"commonjs":"vue-property-decorator","commonjs2":"vue-property-decorator"} ***!
  \*******************************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_vue_property_decorator__;

/***/ }),

/***/ "vue-tsx-support":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"vue-tsx-support","commonjs2":"vue-tsx-support"} ***!
  \*****************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_vue_tsx_support__;

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js":
/*!**********************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js ***!
  \**********************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js":
/*!************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js ***!
  \************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js":
/*!*********************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js ***!
  \*********************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./setPrototypeOf.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__["default"])(subClass, superClass);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js":
/*!**************************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js ***!
  \**************************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./typeof.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./assertThisInitialized.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");


function _possibleConstructorReturn(self, call) {
  if (call && ((0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__["default"])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__["default"])(self);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js":
/*!*******************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js ***!
  \*******************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
/*!***********************!*\
  !*** ./src/index.tsx ***!
  \***********************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TimePickerType": function() { return /* binding */ TimePickerType; },
/* harmony export */   "TimeRangePicker": function() { return /* reexport safe */ _timeRange__WEBPACK_IMPORTED_MODULE_15__["default"]; },
/* harmony export */   "TimeRangePickerType": function() { return /* reexport safe */ _timeRange__WEBPACK_IMPORTED_MODULE_15__.TimeRangePickerType; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _splat_iconfont__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @splat/iconfont */ "@splat/iconfont");
/* harmony import */ var _splat_iconfont__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_splat_iconfont__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./style */ "./src/style.ts");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! moment */ "moment");
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! vue-tsx-support */ "vue-tsx-support");
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! vue-tsx-support/enable-check */ "../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js");
/* harmony import */ var vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _timeRange__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./timeRange */ "./src/timeRange.tsx");









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__["default"])(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};








var TimePickerType;

(function (TimePickerType) {
  TimePickerType["dateTime"] = "datetime";
  TimePickerType["date"] = "date";
  TimePickerType["week"] = "week";
  TimePickerType["month"] = "month";
})(TimePickerType || (TimePickerType = {}));

var TimePicker = /*#__PURE__*/function (_tsx$Component) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__["default"])(TimePicker, _tsx$Component);

  var _super = _createSuper(TimePicker);

  function TimePicker() {
    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, TimePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "value", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "type", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "placeholder", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "disableBeforeNow", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "disableAfterNow", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "readonly", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "disabled", void 0);

    return _this;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(TimePicker, [{
    key: "innerValue",
    get: function get() {
      return this.value ? moment__WEBPACK_IMPORTED_MODULE_10___default().unix(this.value).toDate() : '';
    },
    set: function set(v) {
      this.$emit('input', v ? moment__WEBPACK_IMPORTED_MODULE_10___default()(v).unix() : 0);
    }
  }, {
    key: "format",
    get: function get() {
      switch (this.type) {
        case TimePickerType.week:
          return 'yyyy 第 WW 周';

        default:
          return undefined;
      }
    }
  }, {
    key: "afterFn",
    get: function get() {
      switch (this.type) {
        case TimePickerType.dateTime:
        case TimePickerType.date:
          return function (d) {
            return moment__WEBPACK_IMPORTED_MODULE_10___default()(d) >= moment__WEBPACK_IMPORTED_MODULE_10___default()().startOf('day');
          };

        case TimePickerType.week:
          return function (d) {
            return moment__WEBPACK_IMPORTED_MODULE_10___default()(d) >= moment__WEBPACK_IMPORTED_MODULE_10___default()().startOf('week');
          };

        case TimePickerType.month:
          return function (d) {
            return moment__WEBPACK_IMPORTED_MODULE_10___default()(d) >= moment__WEBPACK_IMPORTED_MODULE_10___default()().startOf('month');
          };
      }
    }
  }, {
    key: "options",
    get: function get() {
      var disableBeforeNow = this.disableBeforeNow,
          disableAfterNow = this.disableAfterNow;
      return {
        disabledDate: disableBeforeNow ? function (d) {
          return moment__WEBPACK_IMPORTED_MODULE_10___default()(d) < moment__WEBPACK_IMPORTED_MODULE_10___default()().startOf('d');
        } : disableAfterNow ? this.afterFn : undefined,
        firstDayOfWeek: 1
      };
    }
  }, {
    key: "render",
    value: function render(h) {
      var _this2 = this;

      var format = this.format,
          type = this.type,
          options = this.options,
          placeholder = this.placeholder,
          readonly = this.readonly,
          disabled = this.disabled;
      return h("el-date-picker", {
        "attrs": {
          "disabled": disabled,
          "readonly": readonly,
          "format": format,
          "type": type,
          "placeholder": placeholder,
          "picker-options": options,
          "prefix-icon": 'none',
          "clear-icon": 'iconfont icon-close',
          "editable": false
        },
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_14__.classes)(_style__WEBPACK_IMPORTED_MODULE_9__.timePickerHackClassName, disabled && _style__WEBPACK_IMPORTED_MODULE_9__.disabledClassName),
        "model": {
          value: _this2.innerValue,
          callback: function callback($$v) {
            _this2.innerValue = $$v;
          }
        }
      });
    }
  }]);

  return TimePicker;
}(vue_tsx_support__WEBPACK_IMPORTED_MODULE_12__.Component);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_11__.Prop)()], TimePicker.prototype, "value", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_11__.Prop)({
  default: TimePickerType.dateTime
})], TimePicker.prototype, "type", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_11__.Prop)()], TimePicker.prototype, "placeholder", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_11__.Prop)()], TimePicker.prototype, "disableBeforeNow", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_11__.Prop)()], TimePicker.prototype, "disableAfterNow", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_11__.Prop)()], TimePicker.prototype, "readonly", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_11__.Prop)()], TimePicker.prototype, "disabled", void 0);

TimePicker = __decorate([vue_property_decorator__WEBPACK_IMPORTED_MODULE_11__.Component], TimePicker);
/* harmony default export */ __webpack_exports__["default"] = (TimePicker);

}();
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map